import { ECommBrand } from 'common/api/e-comm/models/ECommBrand';
import { Card } from 'common/api/e-comm/models/Card';

export type CardWithBrand = Card & { brand?: ECommBrand };

export enum FilterGroup {
    brand = 'brand',
    cardType = 'cardType',
}

export interface Option {
    text: string;
    value: string;
    imageUrl?: string;
    group?: FilterGroup;
}

export interface Group {
    name: string;
    options: Option[];
}

export interface TabContent {
    isActive: boolean;
    brands?: Option[];
}

export interface SortOption extends Pick<Option, 'text' | 'value'> {}
export interface SortOptions {
    addedRecentlyOption: SortOption;
    amountDescOption: SortOption;
    amountAscOption: SortOption;
    lastViewedOption: SortOption;
    nameOption: SortOption;
}
